module.exports = __webpack_public_path__ + "img/VPC.a5074df.svg";